import { tokenStorage } from "shared/api/tokenStorage";
import { decodeJWT } from "../lib/decodeToken";

const mapDecodedTokenToUser = (decoded) => {
  if (!decoded) return null;

  return {
    id: decoded.sub || null,
    email: decoded.login || null,
    role: decoded.role || null,
  };
};

const buildUserStateFromToken = () => {
  const token = tokenStorage.getAccessToken();

  if (!token) {
    return {
      isAuthenticated: false,
      user: null,
      role: null,
    };
  }

  const decoded = decodeJWT(token);
  const user = mapDecodedTokenToUser(decoded);

  if (!user) {
    return {
      isAuthenticated: false,
      user: null,
      role: null,
    };
  }

  return {
    isAuthenticated: true,
    user,
    role: user.role || null,
  };
};

const getInitialUserState = () => buildUserStateFromToken();

let state = getInitialUserState();
const listeners = new Set();

export const userStore = {
  getState() {
    return state;
  },

  setState(patch) {
    state = { ...state, ...patch };
    listeners.forEach((listener) => listener(state));
  },

  setUser(user) {
    state = {
      ...state,
      isAuthenticated: true,
      user,
      role: user?.role || null,
    };
    listeners.forEach((listener) => listener(state));
  },

  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  reset() {
    state = {
      isAuthenticated: false,
      user: null,
      role: null,
    };
    listeners.forEach((listener) => listener(state));
  },
};

export const syncUserFromToken = () => {
  const nextState = buildUserStateFromToken();

  if (!nextState.isAuthenticated) {
    userStore.reset();
    return;
  }

  userStore.setState(nextState);
};
